'use client'

import { useState } from 'react'
import { Card, CardContent, CardFooter } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'
import PersonProfile from './PersonProfile'
import { motion, AnimatePresence } from 'framer-motion'
import { ChevronDown, ChevronUp, Code, Brain } from 'lucide-react'
import { sanitizeBoldOnly } from './OriginalMAList'

export default function AnalogicalMAList({ mapping, people, onPersonClick }) {
    const [expandedReasoning, setExpandedReasoning] = useState({})

    const toggleReasoning = (pid) => {
        setExpandedReasoning(prev => ({
            ...prev,
            [pid]: !prev[pid]
        }))
    }

    return (
        <div className="h-full flex flex-col">
            <div className="flex-1 overflow-y-auto pb-4">
                <div className="space-y-4 p-4">
                    <AnimatePresence>
                        {mapping && Object.entries(mapping).map(([pid, data], index) => {
                            const doe = people.find(p => p.id === pid)

                            return (
                                <motion.div
                                    key={pid}
                                    layout
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="relative"
                                >
                                    <Card
                                        className={`transition-all cursor-pointer`}
                                    >
                                        <CardContent className="pt-6">
                                            <div className="flex justify-between items-start mb-4">
                                                <div className="flex items-start gap-3">
                                                    <span className="text-xl font-bold text-primary min-w-[2rem]">
                                                        {Object.keys(mapping).indexOf(pid) + 1}.
                                                    </span>
                                                    <p
                                                        className="text-lg"
                                                        dangerouslySetInnerHTML={{ __html: sanitizeBoldOnly(data.text) }}
                                                    />
                                                </div>
                                            </div>

                                            {/* <Collapsible
                                                open={expandedReasoning[pid]}
                                                onOpenChange={() => toggleReasoning(pid)}
                                            >
                                                <div className="flex items-center">
                                                    <CollapsibleTrigger asChild>
                                                        <Button variant="ghost" size="sm" className="flex items-center gap-2">
                                                            <Brain className="h-4 w-4" />
                                                            {expandedReasoning[pid] ? "Hide Reasoning" : "Show Reasoning"}
                                                            {expandedReasoning[pid] ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
                                                        </Button>
                                                    </CollapsibleTrigger>
                                                </div>
                                                <CollapsibleContent>
                                                    <div className="mt-2 rounded-md border bg-muted p-4">
                                                        <p className="text-sm">{data.reasoning}</p>
                                                    </div>
                                                </CollapsibleContent>
                                            </Collapsible> */}
                                        </CardContent>

                                        <CardFooter className="flex justify-between border-t pt-4">
                                            <div onClick={(e) => {
                                                e.stopPropagation();
                                                onPersonClick(doe);
                                            }}>
                                                <PersonProfile person={doe} />
                                            </div>
                                        </CardFooter>
                                    </Card>
                                </motion.div>
                            )
                        })}
                    </AnimatePresence>
                    <div className="flex items-center justify-between mt-4 flex-col gap-2">
                        <div className="flex items-center gap-2">
                            <span className="text-sm text-muted-foreground">EmoSync</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="text-sm text-muted-foreground">CHI 2025</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
} 